export default __webpack_public_path__ + "images/sg-e6a27ad3fc2dedabca8b680fae357537.svg";